// extracted by mini-css-extract-plugin
export default {"InfoItem":"InfoItem_InfoItem__KMJ9G","name":"InfoItem_name__QHKwW","date":"InfoItem_date__agjNo"};